(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ss-home-bundles"] && !Shopify.designMode) return;
  try {
    
function initEdgeScroll(root) {
  root.querySelectorAll('[data-ss-edge-scroll]').forEach(function (list) {
    if (list.dataset.ssEdgeReady) return;
    list.dataset.ssEdgeReady = 'true';
    function updateEdges() {
      var maximum = Math.max(0, list.scrollWidth - list.clientWidth);
      list.toggleAttribute('data-ss-can-prev', list.scrollLeft > 2);
      list.toggleAttribute('data-ss-can-next', list.scrollLeft < maximum - 2);
    }
    list.addEventListener('scroll', updateEdges, { passive: true });
    new ResizeObserver(updateEdges).observe(list);
    updateEdges();
  });
}
initEdgeScroll(document);
document.addEventListener('shopify:section:load', function (event) {
  initEdgeScroll(event.target);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ss-home-guides"] && !Shopify.designMode) return;
  try {
    
function initEdgeScroll(root) {
  root.querySelectorAll('[data-ss-edge-scroll]').forEach(function (list) {
    if (list.dataset.ssEdgeReady) return;
    list.dataset.ssEdgeReady = 'true';
    function updateEdges() {
      var maximum = Math.max(0, list.scrollWidth - list.clientWidth);
      list.toggleAttribute('data-ss-can-prev', list.scrollLeft > 2);
      list.toggleAttribute('data-ss-can-next', list.scrollLeft < maximum - 2);
    }
    list.addEventListener('scroll', updateEdges, { passive: true });
    new ResizeObserver(updateEdges).observe(list);
    updateEdges();
  });
}
initEdgeScroll(document);
document.addEventListener('shopify:section:load', function (event) {
  initEdgeScroll(event.target);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ss-polishing-guide"] && !Shopify.designMode) return;
  try {
    
if (!window.ssPolishingGuideBound) {
  window.ssPolishingGuideBound = true;
  document.addEventListener('click', function(event) {
    const reset = event.target.closest('.sspg [data-sspg-reset]');
    if (reset) {
      const guide = reset.closest('.sspg');
      const selected = guide.querySelector('.sspg-goal[aria-expanded="true"]');
      guide.querySelector('.sspg-recommendation').hidden = true;
      guide.querySelectorAll('.sspg-goal').forEach(function(item) { item.setAttribute('aria-expanded', 'false'); });
      if (selected) selected.focus({preventScroll: true});
      return;
    }
    const link = event.target.closest('.sspg [data-sspg-case]');
    if (!link) return;
    const guide = link.closest('.sspg');
    const target = document.getElementById(link.getAttribute('data-sspg-case'));
    if (!target || !guide.contains(target)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (link.matches('.sspg-goal')) {
      const panel = guide.querySelector('.sspg-recommendation');
      const source = target.querySelector('.sspg-detail-body');
      if (panel && source) {
        guide.querySelectorAll('.sspg-goal').forEach(function(item) {
          item.setAttribute('aria-controls', panel.id);
          item.setAttribute('aria-expanded', item === link ? 'true' : 'false');
        });
        panel.querySelector('h3').textContent = link.querySelector('h3').textContent;
        panel.querySelector('.sspg-recommendation-content').replaceChildren(source.cloneNode(true));
        panel.hidden = false;
        panel.querySelector('h3').focus({preventScroll: true});
        return;
      }
    }
  }, true);
}

  } catch(e) { console.error(e); }
})();
})();
